// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';


export const getBannerOwnerById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`banner_owner/${params?.group_user_id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getBannerOwnerGroupUserById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`banner_owner_group_user_id`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};



export const postCreateBannerOwner = async ({ token, params }: any) => {
   // console.log(params)
   //  console.log(params.topup_logo.file);
   let formData = new FormData();
   //  formData.append('topup_logo', params.topup_logo.fileList[0].originFileObj);
   if ( params?.banner_image) {
      formData.append('banner', params.banner_image.file.originFileObj);
   }
   formData.append('banner_name', params.banner_name);
   try {
      return await client
         .post(`banner_owner`, formData, {
            headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'multipart/form-data',
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};